import { AdKind } from '@/api/types/common.types';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';

export function getTestId(type: AdKind, isAuthor = false) {
  if (type === AdKind.Bumped)
    return isAuthor
      ? AdPageTestIds.promotionButton.bumpIsAuthor
      : AdPageTestIds.promotionButton.bump;
  if (type === AdKind.Vipped)
    return isAuthor
      ? AdPageTestIds.promotionButton.vipIsAuthor
      : AdPageTestIds.promotionButton.vip;
  if (type === AdKind.Premium)
    return isAuthor
      ? AdPageTestIds.promotionButton.premiumIsAuthor
      : AdPageTestIds.promotionButton.premium;
}

export function getPromotionId(type: AdKind) {
  switch (type) {
    case AdKind.Bumped:
      return 'add_bump';
    case AdKind.Vipped:
      return 'add_vip';
    default:
      return undefined;
  }
}
